import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-periodo-actual',
  templateUrl: './periodo-actual.component.html',
  styleUrls: ['./periodo-actual.component.scss'],
  providers: [DatePipe]
})
export class PeriodoActualComponent implements OnInit {
  matriculadas = [];
  pantalla = 1;
  tituloPantalla = "PERIODO ACTUAL";

  @Input() ahora: Date = null;
  @Input() cintillo = "";
  @Input() sedes = [];
  @Input() periodos = [];
  @Input() carreras = [];
  @Input() sedeSeleccionada = null;
  @Input() periodoSeleccionado = null;
  @Input() M04IUP = null;
  
  strIconoQuestion = "assets/images/Icon_Alerta-Pregunta_Avatar-SyS.png";

  @ViewChild('modalConfirmar') contenido: TemplateRef<any>;

  constructor(private modalService: NgbModal, private datePipe: DatePipe) { }

  ngOnInit(): void {
    //this.ahora = new Date();
  }

  cambiarPantalla(numero, titulo){
    this.pantalla = numero;
    this.tituloPantalla = titulo;
  }

  confirmarCambioGrupo(){
    Swal.fire({
      title: '¿Confirmar el cambio al grupo seleccionado?',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      iconHtml:'<img src="'+ this.strIconoQuestion + '">',
      customClass:{
        icon:'swal2-icono-custom'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalService.open(this.contenido, {centered: true, modalDialogClass: 'modal-mitad'});
      }
    })
  }

}
